import axios from 'axios';
import { Message, Loading } from 'element-ui';
axios.defaults.timeout = 60000;
axios.defaults.baseURL = 'http://bsapi.zxh.weilaiw.com';//线上//
// axios.defaults.baseURL = 'http://csbsapi.zxh1.weilaiw.com/';//线上测试

// axios.defaults.baseURL = 'http://zxh001.sgy.icp021.com/';//晓辉
// axios.defaults.baseURL = 'http://192.168.8.220:8087/';//郭首辰
axios.defaults.withCredentials = true;
const Url = [
    "http://bsapi.zxh.weilaiw.com/api/Countphone/xsjListExect"
];

axios.interceptors.request.use(
    config => {
        Url.forEach(element => {
            if (config.url == element) {
                config.timeout = '300000'
            }
        });
        return config;
    },
    error => {
        error.data = {}
        error.data.msg = '服务器异常，请联系管理员！'
        return Promise.resolve(error)
})
axios.interceptors.response.use(response => {
  if (response.data.code == 202) {
    Message({ message: "登陆失效", type: 'error' });
    window.location = "/login"
  }
  if (response.data.code != 200) {
    Message({ message: response.data.msg, type: 'error', showClose: true, });
  }
  return response;
}, error => {
  if (error.response.status === 404) {
    Message({ message: "网络请求不存在", type: 'error' });
}
if (error.response.status === 500) {
    Message({ message: "服务器请求错误", type: 'error' });
}
  return Promise.reject(error);
});
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
var loadingInstance = null;
export function get(url, params = {}, loading) {
  if (loading) {
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.2)'
    });
  }
  // if(sessionStorage.getItem("token")){
  // 	var Obj = {"token":sessionStorage.getItem("token").replace(/\"/g,"")}
  // 	params = Object.assign(Obj, params);
  // }
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
    }).then(response => {
      if (loading) loadingInstance.close();
      resolve(response);
    }).catch(err => {
        console.log(111)
      if (loading) loadingInstance.close();
      reject(err);
    });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, loading,config={}) {
  if (loading) {
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.2)'
    });
  }
  // if(sessionStorage.getItem("token")){
  // 	var Obj = {"token":sessionStorage.getItem("token").replace(/\"/g,"")}
  // 	data = Object.assign(Obj, data);
  // }
  return new Promise((resolve, reject) => {
    axios.post(url, data,config).then(response => {
      if (loading) loadingInstance.close();
      resolve(response);
    }, err => {
      if (loading) loadingInstance.close();
      reject(err);
    });
  });
}

